import React, { useState } from 'react';
import { Container, Card, Button, ButtonGroup } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';
import { PublicHeader } from '../common';
import api from '../../services/api';
import './OfferPage.css';

const OfferPage = () => {
  const { t } = useLanguage();
  const [language, setLanguage] = useState('uae'); // 'uae' or 'china'
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const url = `${api.baseUrl}/offer/download/?language=${language}`;
      const token = api.getToken();
      
      const headers = {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      
      const response = await fetch(url, {
        method: 'GET',
        headers,
      });
      
      if (!response.ok) {
        let errorText = 'Failed to download offer document';
        try {
          const errorData = await response.json();
          errorText = errorData.errorText || errorText;
        } catch (e) {
          // If response is not JSON, use default error
        }
        throw new Error(errorText);
      }
      
      // Get blob from response
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      
      // Set filename based on language
      const filename = language === 'uae' ? 'UAE_offer.docx' : 'CHN_offer.docx';
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      console.error('Error downloading offer:', err);
      alert(err.message || t('offer.downloadError') || 'Failed to download offer document');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <PublicHeader />
      <Container className="py-5 offer-page">
      <Card className="border-0 shadow-sm">
        <Card.Header className="bg-transparent border-bottom">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            <h2 className="mb-0 fw-bold">{t('offer.title')}</h2>
            <ButtonGroup>
              <Button
                variant={language === 'uae' ? 'primary' : 'outline-primary'}
                onClick={() => setLanguage('uae')}
                disabled={downloading}
              >
                {t('offer.languageUAE')}
              </Button>
              <Button
                variant={language === 'china' ? 'primary' : 'outline-primary'}
                onClick={() => setLanguage('china')}
                disabled={downloading}
              >
                {t('offer.languageChina')}
              </Button>
            </ButtonGroup>
          </div>
        </Card.Header>
        <Card.Body className="p-5 text-center">
          <div className="mb-4">
            <i className="bi bi-file-earmark-word display-1 text-primary mb-3"></i>
            <h4 className="mb-3">{t('offer.selectLanguage')}</h4>
            <p className="text-muted mb-4">
              {language === 'uae' 
                ? t('offer.uaeDescription') 
                : t('offer.chinaDescription')}
            </p>
          </div>
          <Button
            variant="primary"
            size="lg"
            onClick={handleDownload}
            disabled={downloading}
            className="px-5"
          >
            {downloading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {t('offer.downloading')}
              </>
            ) : (
              <>
                <i className="bi bi-download me-2"></i>
                {t('offer.download')}
              </>
            )}
          </Button>
        </Card.Body>
      </Card>
    </Container>
    </>
  );
};

export default OfferPage;

